/*!

=========================================================
* BLK Design System React - v1.2.2 - Test
=========================================================

* Product Page: https://www.creative-tim.com/product/blk-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/blk-design-system-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import classnames from "classnames";
// reactstrap components
import {
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

export default function AboutUs() {
  const [iconTabs, setIconsTabs] = React.useState(1);
  const [textTabs, setTextTabs] = React.useState(4);
  return (
    <div id="about-us" className="section section-tabs">
      <Container>
        <div className="title">
          <h3 className="mb-3">About Us</h3>
        </div>
        <Row>
          <Col className="ml-auto mr-auto" md="10" xl="6">
            <Card>
              <CardHeader>
                <Nav className="nav-tabs-info" role="tablist" tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: iconTabs === 1,
                      })}
                      onClick={(e) => setIconsTabs(1)}
                      href="#"
                    >
                      <i className="tim-icons icon-single-copy-04" />
                      Summary
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: iconTabs === 2,
                      })}
                      onClick={(e) => setIconsTabs(2)}
                      href="#"
                    >
                      <i className="tim-icons icon-spaceship " />
                      Our Mission
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardHeader>
              <CardBody>
                <TabContent
                  style={{ textAlign: "justify" }}
                  className="tab-space"
                  activeTab={"link" + iconTabs}
                >
                  <TabPane tabId="link1">
                    <p>
                      C-HUB (Pty) Ltd is a private company operating at the
                      intersection of software engineering and connected
                      devices. Our core business is device integration in the
                      IoT space-connecting medical devices, sensors, and
                      industrial hardware to cloud platforms through reliable,
                      secure software.
                      <br />
                      <br />
                      We specialise in taking devices that speak raw protocols
                      (BLE, UART, NFC, GSM) and transforming them into seamless,
                      data-driven solutions. Whether it's integrating 10+ BLE
                      medical devices into a health platform or architecting
                      cloud-native microservices, we bridge the gap between
                      hardware and the digital world.
                      <br />
                      <br />
                      We are a trusted partner to organisations looking to
                      unlock the value of their connected devices, and to
                      engineers seeking a home where they can grow their skills
                      in embedded systems, IoT, and cloud architecture.
                    </p>
                  </TabPane>
                  <TabPane tabId="link2">
                    <p>
                      C-HUB delivers high-quality software development with a
                      focus on clean architecture, security, and reliable
                      delivery. Our specialisation is device integration in the
                      IoT space-connecting hardware to the cloud through robust,
                      scalable systems.
                      <br />
                      <br />
                      We partner with clients to solve complex problems,
                      bringing deep technical expertise in embedded systems,
                      BLE, microservices, and cloud infrastructure. We
                      communicate clearly, deliver consistently, and build
                      things that work.
                    </p>
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
          <Col className="ml-auto mr-auto" md="10" xl="6">
            <Card>
              <CardHeader>
                <Nav className="nav-tabs-info" role="tablist" tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: textTabs === 4,
                      })}
                      onClick={(e) => setTextTabs(4)}
                      href="#"
                    >
                      <i className="tim-icons icon-single-02" />
                      The team
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: textTabs === 5,
                      })}
                      onClick={(e) => setTextTabs(5)}
                      href="#"
                    >
                      <i className="tim-icons icon-square-pin" />
                      Location
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardHeader>
              <CardBody>
                <TabContent className="tab-space" activeTab={"link" + textTabs}>
                  <TabPane tabId="link4">
                    <Row className="mt-5 mt-sm-5 text-center">
                      <Col sm="3" xs="6">
                        <img
                          alt="..."
                          className="img-fluid rounded shadow"
                          src={require("assets/img/wilson_cardoso_profile_pic.png")}
                          style={{ width: "100px", height: "135px" }}
                        />
                        <small className="d-block text-uppercase font-weight-bold mt-4">
                          Wilson Cardoso
                        </small>

                        <span
                          className="d-block text-muted"
                          style={{ fontSize: "0.7rem" }}
                        >
                          Director / Software Engineer
                        </span>
                      </Col>
                      <Col sm="3" xs="6">
                        <img
                          alt="..."
                          className="img-fluid rounded shadow"
                          src={require("assets/img/lauren_cardoso_profile_pic.png")}
                          style={{ width: "100px", height: "135px" }}
                        />
                        <small className="d-block text-uppercase font-weight-bold mt-4">
                          Lauren Cardoso
                        </small>
                        <span
                          className="d-block text-muted"
                          style={{ fontSize: "0.7rem" }}
                        >
                          HR Admin
                        </span>
                      </Col>
                      <Col sm="3" xs="6">
                        <img
                          alt="..."
                          className="img-fluid rounded shadow"
                          src={require("assets/img/jose_isaias_profile_pic.png")}
                          style={{ width: "100px", height: "135px" }}
                        />
                        <small className="d-block text-uppercase font-weight-bold mt-4">
                          José Isaías
                        </small>
                        <span
                          className="d-block text-muted"
                          style={{ fontSize: "0.7rem" }}
                        >
                          Software Engineer
                        </span>
                      </Col>
                      <Col sm="3" xs="6">
                        <img
                          alt="..."
                          className="img-fluid rounded shadow"
                          src={require("assets/img/wilson_fernando_profile.jpg")}
                          style={{ width: "100px", height: "135px" }}
                        />
                        <small className="d-block text-uppercase font-weight-bold mt-4">
                          Wilson Fernando
                        </small>
                        <span
                          className="d-block text-muted"
                          style={{ fontSize: "0.7rem" }}
                        >
                          Software Engineer
                        </span>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="link5">
                    <p>Our team work remotely from the following locations</p>
                    <Row className="mt-5 mt-sm-5 text-center">
                      <Col sm="3" xs="6">
                        <img
                          alt="..."
                          className="img-fluid rounded shadow"
                          src={require("assets/img/icons8-location-100.png")}
                          style={{ width: "50px" }}
                        />
                        <small className="d-block text-uppercase font-weight-bold mt-2">
                          South Africa
                        </small>
                      </Col>
                      <Col sm="3" xs="6">
                        <img
                          alt="..."
                          className="img-fluid rounded shadow"
                          src={require("assets/img/icons8-location-100.png")}
                          style={{ width: "50px" }}
                        />
                        <small className="d-block text-uppercase font-weight-bold mt-2">
                          Angola
                        </small>
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
